"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SORT_KEYS = exports.NESTED_REPLIES_PAGE_SIZE = exports.DEFAULT_SORT = void 0;
var SORT_KEYS = {
  OLDEST_FIRST: 'oldestFirst',
  NEWEST_FIRST: 'mostRecentFirst',
  BEST_VOTED: 'mostLiked'
};
exports.SORT_KEYS = SORT_KEYS;
var DEFAULT_SORT = SORT_KEYS.OLDEST_FIRST;
exports.DEFAULT_SORT = DEFAULT_SORT;
var NESTED_REPLIES_PAGE_SIZE = 20;
exports.NESTED_REPLIES_PAGE_SIZE = NESTED_REPLIES_PAGE_SIZE;